import type { ExcursionComponentProps } from "@op/puck-types";
import { ExcursionRenderer } from "../../../../../renderer";

const Excursion = ({ data, slug }: ExcursionComponentProps) => {
  return (
    <div id={`excursion-${slug}`} style={{ breakBefore: "page" }}>
      <ExcursionRenderer data={data} />
    </div>
  );
};

export default Excursion;
